import React from 'react';
import { DialogTitle, DialogContent, DialogActions, DialogContentText, Button } from '@mui/material';
import { colors } from 'Constants/Colors';
import useTranslation from 'Hooks/useTranslation';
import useUpdate from '../Hooks/useUpdate';

export default function ModalEdit({
  data = null,
  cancel = () => {},
  accept = () => {},
  allDepartments = [],
  setAllDepartments = () => {},
}) {
  const { t } = useTranslation();
  const { handleClick } = useUpdate({
    data,
    cancel,
    allDepartments,
    setAllDepartments,
  });
  return (
    <div className="col">
      <DialogTitle
        style={{
          fontWeight: 'bold',
          color: colors.BLACK,
          fontFamily: 'quicksand',
        }}
      >
        {t('Department.ModifyStatus')}
      </DialogTitle>
      <DialogContent className="col">
        <DialogContentText style={{ fontFamily: 'metropolis' }}>{t('Department.DialogMsg')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button style={{ fontFamily: 'quicksand' }} color="success" variant="outlined" onClick={cancel}>
          {t('Generic.Cancel')}
        </Button>
        <Button
          style={{ fontFamily: 'quicksand' }}
          color="success"
          onClick={async () => {
            await handleClick();
            accept();
          }}
          variant="contained"
        >
          {t('Generic.Accept')}
        </Button>
      </DialogActions>
    </div>
  );
}
